/* Marcel Afters: card pass (24 Sep 2026).
   Bruce: "every image, when you hover, should show a secondary image and should be clickable to shop, not just images."
   Quick shop on every product card (collection grids, home rows, range carousels, Pairs with / Complete the set rails).

   - Desktop (hover + fine pointer): a white bar slides up over the bottom of the image on hover or keyboard focus.
     Sizes are small buttons; a size adds that size to the bag and the cart drawer opens.
   - Touch: a "+" in the image corner opens a bottom sheet with the sizes; tapping a size adds it (Bruce 25 Sep:
     "instant add to carts is key"). A product with no sizes is added by the "+" itself.
   - The colour added is the one the card photo shows (variant linked to that image, else named in its alt), unless
     the shopper picked a colour dot or chip.
   - Keyboard: everything is focusable, the bar opens on focus, Escape closes the bar or the sheet.
   - Nothing here touches the image or title links; the markup comes from snippets/ma-quickshop.liquid.
   - The picker is built from /products/<handle>.js the first time a card is pointed at (cached), so pages stay light.
   - Adds go through the theme's own CartLinesUpdateEvent, so the drawer, bag count and cart page update as usual.
     If that module cannot load, the item is still added and the picker says "Added" with a link to the bag. */
(function () {
  'use strict';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SCOPE = 'product-card, .ma-rc__item, .ma-pairs__item';
  var cache = {};
  var sheet = null, sheetHost = null, opener = null;

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function hostIn(node) {
    if (!node || !node.closest) return null;
    var h = node.closest('[data-ma-qs]');
    if (h) return h;
    var s = node.closest(SCOPE);
    return s ? s.querySelector('[data-ma-qs]') : null;
  }
  function scopeOf(host) { return host.closest(SCOPE) || host.parentElement; }

  /* ---------- data ---------- */
  function load(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('product ' + r.status); return r.json(); })
        .catch(function (e) { delete cache[handle]; throw e; });
    }
    return cache[handle];
  }
  function model(p) {
    var names = (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    var ci = -1, si = -1, extra = false;
    names.forEach(function (n, i) {
      if (/^colou?r$/i.test(n)) ci = i;
      else if (/^size$/i.test(n)) si = i;
      else if (!(names.length === 1 && /^title$/i.test(n))) {
        var seen = {};
        p.variants.forEach(function (v) { seen[v.options[i]] = 1; });
        if (Object.keys(seen).length > 1) extra = true;
      }
    });
    var colours = [];
    if (ci > -1) p.variants.forEach(function (v) { if (colours.indexOf(v.options[ci]) < 0) colours.push(v.options[ci]); });
    return { ci: ci, si: si, extra: extra, colours: colours };
  }
  function ensure(host) {
    if (host._ma) return Promise.resolve(host._ma);
    if (host._maP) return host._maP;
    host._maP = load(host.dataset.handle).then(function (p) {
      host._ma = { p: p, m: model(p), colour: null, size: null, busy: false, msg: '', err: false, fallback: false };
      repaint(host);
      return host._ma;
    }, function () {
      host._ma = { failed: true };
      repaint(host);
      return host._ma;
    });
    return host._maP;
  }

  /* ---------- state helpers ---------- */
  function fileBase(u) {
    var s = String(u || '').split('?')[0].split('/').pop() || '';
    return s.replace(/_(\d+x\d*|\d*x\d+)(?=\.[a-z]+$)/i, '').toLowerCase();
  }
  function sellable(d, col) {
    for (var i = 0; i < d.p.variants.length; i++) if (d.p.variants[i].available && d.p.variants[i].options[d.m.ci] === col) return true;
    return false;
  }
  // The colour the card photo shows: a variant linked to that image, else a colour named in its alt text.
  function imageColour(host) {
    var d = host._ma, m = d.m;
    if (host.dataset.colour && m.colours.indexOf(host.dataset.colour) > -1) return host.dataset.colour;
    var img = scopeOf(host).querySelector('.ma-rc__front, .ma-st__front, img');
    if (!img) return null;
    var base = fileBase(img.currentSrc || img.src);
    if (base) {
      for (var i = 0; i < d.p.variants.length; i++) {
        var fi = d.p.variants[i].featured_image;
        if (fi && fileBase(fi.src) === base) return d.p.variants[i].options[m.ci];
      }
    }
    var alt = (img.alt || '').toLowerCase(), best = null;
    m.colours.forEach(function (c) { if (alt.indexOf(String(c).toLowerCase()) > -1 && (!best || c.length > best.length)) best = c; });
    return best;
  }
  function currentColour(host) {
    var d = host._ma, m = d.m;
    if (m.ci < 0) return null;
    if (d.colour && m.colours.indexOf(d.colour) > -1) return d.colour;
    var chosen = scopeOf(host).querySelector('.ma-sw__dot[aria-pressed="true"]');
    var fromDot = null;
    if (chosen && chosen.dataset.variant) {
      var vid = Number(chosen.dataset.variant);
      for (var i = 0; i < d.p.variants.length; i++) if (d.p.variants[i].id === vid) fromDot = d.p.variants[i].options[m.ci];
    }
    if (fromDot && d.dot) return fromDot;
    if (d.imgCol === undefined) d.imgCol = imageColour(host);
    if (d.imgCol) return d.imgCol;
    if (fromDot) return fromDot;
    return m.colours.length === 1 ? m.colours[0] : null;
  }
  function variantsFor(host) {
    var d = host._ma, col = currentColour(host);
    if (d.m.ci > -1 && col == null) return [];
    return d.p.variants.filter(function (v) { return d.m.ci < 0 || v.options[d.m.ci] === col; });
  }
  function selectedVariant(host) {
    var d = host._ma, vs = variantsFor(host);
    if (d.m.si < 0) {
      for (var i = 0; i < vs.length; i++) if (vs[i].available) return vs[i];
      return null;
    }
    for (var j = 0; j < vs.length; j++) if (vs[j].options[d.m.si] === d.size && vs[j].available) return vs[j];
    return null;
  }

  /* ---------- painting ---------- */
  function paint(host, pick, mode) {
    var d = host._ma;
    pick.textContent = '';
    if (!d) { pick.appendChild(el('span', 'ma-qs__label', 'Quick shop')); return; }
    if (d.failed || d.m.extra) {
      var a = el('a', 'ma-qs__link', d.failed ? 'View product' : 'Choose options');
      a.href = host.dataset.url;
      pick.appendChild(a);
      return;
    }
    var head = el('div', 'ma-qs__head');
    if (mode === 'bar') head.appendChild(el('span', 'ma-qs__label', 'Quick shop'));
    var msg = el('span', 'ma-qs__msg' + (d.err ? ' is-err' : ''));
    msg.textContent = d.msg || '';
    if (d.fallback) {
      msg.textContent = d.err ? (d.msg || 'Could not confirm.') + ' ' : 'Added. ';
      var view = el('a', 'ma-qs__view', 'View bag');
      view.href = ROOT + 'cart';
      msg.appendChild(view);
    }
    if (mode === 'bar') { head.appendChild(msg); pick.appendChild(head); }

    var col = currentColour(host);
    if (d.m.colours.length > 1) {
      var cg = el('div', 'ma-qs__row ma-qs__colours');
      cg.setAttribute('role', 'group');
      cg.setAttribute('aria-label', 'Colour');
      d.m.colours.forEach(function (c) {
        var b = el('button', 'ma-qs__chip', c);
        b.type = 'button';
        b.dataset.colour = c;
        b.setAttribute('aria-pressed', c === col ? 'true' : 'false');
        cg.appendChild(b);
      });
      pick.appendChild(cg);
    }

    var vs = variantsFor(host);
    if (d.m.ci > -1 && col == null) pick.appendChild(el('span', 'ma-qs__hint', 'Choose a colour before adding a size.'));
    if (col && !sellable(d, col)) pick.appendChild(el('span', 'ma-qs__hint', col + ' is sold out. Choose another colour to continue.'));
    if (d.m.si > -1) {
      var sg = el('div', 'ma-qs__row ma-qs__sizes');
      sg.setAttribute('role', 'group');
      sg.setAttribute('aria-label', 'Size');
      vs.forEach(function (v) {
        var s = v.options[d.m.si];
        var b = el('button', 'ma-qs__size', s);
        b.type = 'button';
        b.dataset.vid = v.id;
        b.dataset.size = s;
        if (!v.available) { b.disabled = true; b.setAttribute('aria-label', s + ', sold out'); }
        else b.setAttribute('aria-label', 'Add size ' + s + ' to bag');
        if (d.busy && d.size === s) { b.setAttribute('aria-pressed', 'true'); b.setAttribute('aria-busy', 'true'); }
        sg.appendChild(b);
      });
      if (mode === 'sheet') pick.appendChild(el('span', 'ma-qs__hint', col ? col + '. Tap a size to add it to your bag.' : 'Tap a size to add it to your bag.'));
      pick.appendChild(sg);
    }
    // A size adds by itself (bar and sheet); products with no size get one button.
    if (d.m.si < 0) {
      var add = el('button', 'ma-qs__add', d.busy ? 'Adding' : 'Add to bag');
      add.type = 'button';
      if (d.busy) add.setAttribute('aria-busy', 'true');
      if (d.m.si < 0 && !selectedVariant(host)) { add.disabled = true; add.textContent = 'Sold out'; }
      pick.appendChild(add);
    }
    if (mode === 'sheet') pick.appendChild(msg);
  }
  function repaint(host) {
    var bar = host.querySelector('[data-ma-qs-pick]');
    if (bar) paint(host, bar, 'bar');
    if (sheet && sheetHost === host) paint(host, sheet.pick, 'sheet');
  }

  /* ---------- add to bag ---------- */
  function sectionIds() {
    var ids = [];
    [].forEach.call(document.querySelectorAll('cart-items-component'), function (n) { if (n.dataset && n.dataset.sectionId) ids.push(n.dataset.sectionId); });
    return ids;
  }
  var live = null;
  function announce(text) {
    if (!live) {
      live = el('div', 'ma-qs__live');
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      live.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0';
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 50);
  }
  function say(host, text, err, ms) {
    var d = host._ma;
    d.msg = text; d.err = !!err;
    if (text) announce(text === 'Adding' ? 'Adding to bag' : (text === 'Added' ? 'Added to bag' : text));
    repaint(host);
    clearTimeout(d.t);
    if (ms) d.t = setTimeout(function () { d.msg = ''; d.err = false; d.fallback = false; repaint(host); }, ms);
  }
  async function readCart(routes) {
    var url = new URL(routes.cart_url || (ROOT + 'cart'), location.origin);
    url.pathname = url.pathname.replace(/\/$/, '') + '.js';
    var response = await fetch(url.href, { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('Could not review your bag.');
    var cart = await response.json();
    if (!cart || !Array.isArray(cart.items) || cart.items.some(function (item) { return !String(item.variant_id || item.id || '') || !Number.isInteger(item.quantity) || item.quantity < 0; })) throw new Error('Could not review your bag.');
    return cart;
  }
  function cartState(cart) {
    var quantities = {}, lines = {};
    cart.items.forEach(function (item) {
      var id = String(item.variant_id || item.id);
      var properties = Object.entries(item.properties || {}).sort(function (a, b) { return a[0].localeCompare(b[0]); });
      var signature = JSON.stringify([id, properties, item.selling_plan_allocation && item.selling_plan_allocation.selling_plan ? item.selling_plan_allocation.selling_plan.id : null]);
      quantities[id] = (quantities[id] || 0) + item.quantity;
      lines[signature] = (lines[signature] || 0) + item.quantity;
    });
    return { quantities: quantities, lines: lines, currency: cart.currency, note: cart.note, attributes: JSON.stringify(Object.entries(cart.attributes || {}).sort(function (a, b) { return a[0].localeCompare(b[0]); })) };
  }
  function reconcile(cart, operation) {
    var before = operation.before, after = cartState(cart), id = String(operation.variant.id);
    if ((before.currency && after.currency !== before.currency) || before.note !== after.note || before.attributes !== after.attributes) return null;
    var signatures = new Set(Object.keys(before.lines).concat(Object.keys(after.lines)));
    for (var signature of signatures) {
      var lineId = JSON.parse(signature)[0], oldQuantity = before.lines[signature] || 0, newQuantity = after.lines[signature] || 0;
      if ((lineId !== id && oldQuantity !== newQuantity) || (lineId === id && newQuantity < oldQuantity)) return null;
    }
    var delta = (after.quantities[id] || 0) - (before.quantities[id] || 0);
    return delta === 0 || delta === 1 ? delta : null;
  }
  async function add(host, v) {
    var d = host._ma;
    if (!d || d.busy) return;
    d.busy = true; d.fallback = false;
    say(host, 'Adding', false, 0);
    var mod = null, def = null, cart = null, json = null, ok = false;
    var routes = (window.Theme && Theme.routes) || {};
    try {
      cart = await readCart(routes);
      if (d.operation) {
        if (String(d.operation.variant.id) !== String(v.id)) throw new Error('Review your bag before changing this selection.');
        var priorDelta = reconcile(cart, d.operation);
        if (priorDelta == null) throw new Error('Your bag changed. Review it before another attempt.');
        if (priorDelta === 0 && d.operation.transportUnknown) throw new Error('The earlier request is not confirmed. Review your bag before another attempt.');
        ok = priorDelta === 1;
      } else {
        d.operation = { before: cartState(cart), variant: v, transportUnknown: false };
      }
      try { mod = await import('@shopify/events'); } catch (e) { mod = null; }
      if (mod && mod.CartLinesUpdateEvent) {
        try {
          def = mod.CartLinesUpdateEvent.createPromise();
          host.dispatchEvent(new mod.CartLinesUpdateEvent({
            action: 'add', context: 'product',
            lines: [{ merchandiseId: String(v.id), quantity: 1 }],
            promise: def.promise
          }));
        } catch (e) { def = null; }
      }
      if (!ok) {
        var fd = new FormData();
        fd.append('id', v.id);
        fd.append('quantity', '1');
        var ids = sectionIds();
        if (ids.length) fd.append('sections', ids.join(','));
        d.operation.transportUnknown = true;
        try {
          var res = await fetch(routes.cart_add_url || (ROOT + 'cart/add.js'), { method: 'POST', credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: fd });
          json = await res.json();
          d.operation.transportUnknown = false;
        } catch (e) { json = { description: 'The bag request could not be confirmed.' }; }
        cart = await readCart(routes);
        var delta = reconcile(cart, d.operation);
        if (delta == null) throw new Error('Your bag changed. Review it before another attempt.');
        if (delta !== 1) throw new Error((json && (json.description || json.message)) || 'Could not confirm that size.');
        ok = true;
      }
      if (def) {
        def.resolve({
          cart: mod.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { items: cart.items, source: 'ma-quickshop', sourceId: host.id || 'ma-quickshop', itemCount: 1, productId: String(d.p.id), sections: json && json.sections, didError: false }
        });
      }
      d.operation = null;
    } catch (failure) {
      ok = false;
      if (def) {
        if (cart) def.resolve({
          cart: mod.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { items: cart.items, source: 'ma-quickshop', sourceId: host.id || 'ma-quickshop', itemCount: 0, productId: String(d.p.id), didError: true }
        });
        else def.reject(failure);
      }
      d.fallback = true;
      say(host, (failure.message || 'Could not confirm that size.') + ' Check your bag before trying again.', true, 0);
    } finally { d.busy = false; }
    if (ok) {
      d.size = null;
      if (sheet && sheetHost === host) closeSheet(!!def);
      if (def) say(host, 'Added', false, 2400);
      else { d.fallback = true; say(host, '', false, 6000); }
    } else { repaint(host); }
  }

  /* ---------- bottom sheet (touch) ---------- */
  function ensureSheet() {
    if (sheet) return sheet;
    var root = el('div', 'ma-qs-sheet');
    root.hidden = true;
    var scrim = el('div', 'ma-qs-sheet__scrim');
    scrim.dataset.maQsClose = '';
    var panel = el('div', 'ma-qs-sheet__panel');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-labelledby', 'ma-qs-sheet-t');
    panel.tabIndex = -1;
    var top = el('div', 'ma-qs-sheet__top');
    var title = el('p', 'ma-qs-sheet__title');
    title.id = 'ma-qs-sheet-t';
    var x = el('button', 'ma-qs-sheet__x');
    x.type = 'button'; x.dataset.maQsClose = ''; x.setAttribute('aria-label', 'Close quick shop'); x.innerHTML = '<span aria-hidden="true">&times;</span>';
    top.appendChild(title); top.appendChild(x);
    var pick = el('div', 'ma-qs__pick');
    var more = el('a', 'ma-qs-sheet__more', 'View full details');
    panel.appendChild(top); panel.appendChild(pick); panel.appendChild(more);
    root.appendChild(scrim); root.appendChild(panel);
    document.body.appendChild(root);
    sheet = { root: root, panel: panel, title: title, pick: pick, more: more };
    return sheet;
  }
  function openSheet(host, from) {
    var s = ensureSheet();
    sheetHost = host; opener = from || null;
    s.title.textContent = host.dataset.title || '';
    s.more.href = host.dataset.url;
    paint(host, s.pick, 'sheet');
    s.root.hidden = false;
    document.documentElement.classList.add('ma-qs-lock');
    requestAnimationFrame(function () { s.root.classList.add('is-open'); });
    ensure(host).then(function () { if (sheetHost === host) { paint(host, s.pick, 'sheet'); } });
    setTimeout(function () { var f = s.panel.querySelector('button:not([disabled]), a[href]'); (f || s.panel).focus(); }, 30);
  }
  function closeSheet(keepFocus) {
    if (!sheet || sheet.root.hidden) return;
    var back = opener;
    sheet.root.classList.remove('is-open');
    document.documentElement.classList.remove('ma-qs-lock');
    var done = function () { sheet.root.hidden = true; };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) done(); else setTimeout(done, 200);
    sheetHost = null; opener = null;
    if (back && !keepFocus && back.focus) back.focus();
  }

  /* ---------- events ---------- */
  function warm(e) {
    if (e.pointerType === 'touch') return;
    var h = hostIn(e.target);
    if (h) ensure(h);
  }
  document.addEventListener('pointerover', warm, { passive: true });
  document.addEventListener('focusin', function (e) { var h = hostIn(e.target); if (h) ensure(h); });
  document.addEventListener('touchstart', function (e) { var h = hostIn(e.target); if (h) ensure(h); }, { passive: true });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    // A colour dot on the card changes which colour the picker shows.
    var dot = t.closest('.ma-sw__dot');
    if (dot) {
      var dh = hostIn(dot);
      if (dh && dh._ma) setTimeout(function () { dh._ma.colour = null; dh._ma.size = null; dh._ma.dot = true; repaint(dh); }, 0);
      return;
    }
    var closer = t.closest('[data-ma-qs-close]');
    if (closer) { e.preventDefault(); closeSheet(); return; }
    var op = t.closest('[data-ma-qs-open]');
    if (op) {
      e.preventDefault(); e.stopPropagation();
      var oh = op.closest('[data-ma-qs]');
      if (!oh) return;
      // One size, one colour to buy: "+" adds straight away. Anything with sizes opens the size sheet.
      var direct = function (d) {
        if (!d || d.failed || d.m.extra || d.m.si > -1) return false;
        var v = selectedVariant(oh);
        if (!v) return false;
        add(oh, v);
        return true;
      };
      if (oh._ma) { if (!direct(oh._ma)) openSheet(oh, op); return; }
      op.setAttribute('aria-busy', 'true');
      ensure(oh).then(function (d) { op.removeAttribute('aria-busy'); if (!direct(d)) openSheet(oh, op); });
      return;
    }
    var inSheet = sheet && sheet.panel.contains(t);
    var host = inSheet ? sheetHost : hostIn(t);
    if (!host || !host._ma) return;
    var d = host._ma;
    var chip = t.closest('.ma-qs__chip');
    if (chip) {
      e.preventDefault();
      d.colour = chip.dataset.colour;
      if (d.m.si > -1 && !variantsFor(host).some(function (v) { return v.options[d.m.si] === d.size && v.available; })) d.size = null;
      repaint(host);
      return;
    }
    var size = t.closest('.ma-qs__size');
    if (size && !size.disabled) {
      e.preventDefault(); e.stopPropagation();
      d.size = size.dataset.size;
      var v = selectedVariant(host);
      if (v) add(host, v);
      return;
    }
    var btn = t.closest('.ma-qs__add');
    if (btn && !btn.disabled) {
      e.preventDefault(); e.stopPropagation();
      var sv = selectedVariant(host);
      if (!sv) { say(host, 'Choose a size', true, 3000); return; }
      add(host, sv);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (sheet && !sheet.root.hidden) { e.preventDefault(); closeSheet(); return; }
      var ae = document.activeElement, sc = ae && ae.closest ? ae.closest(SCOPE) : null, h = sc && sc.querySelector('[data-ma-qs]');
      var bar = h && h.querySelector('.ma-qs__bar');
      if (bar && getComputedStyle(bar).visibility === 'visible') {
        e.preventDefault();
        h.classList.add('is-dismissed');
        // focus inside the bar goes back to the card's own link so the keyboard is not left on a hidden control
        if (h.contains(ae)) {
          var link = sc.querySelector('a.product-card__link, a[href]');
          if (link && link.focus) link.focus({ preventScroll: true });
        }
        var clear = function () { h.classList.remove('is-dismissed'); sc.removeEventListener('pointerleave', clear); sc.removeEventListener('focusout', clear); };
        sc.addEventListener('pointerleave', clear); sc.addEventListener('focusout', clear);
      }
      return;
    }
    if (e.key === 'Tab' && sheet && !sheet.root.hidden) {
      var f = sheet.panel.querySelectorAll('button:not([disabled]), a[href]');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === sheet.panel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
})();

/* Product page gallery on phones (Bruce, 24 Sep): landscape photographs keep their own shape instead of sitting in the
   tall portrait frame the tallest picture sets. When a gallery holds any landscape picture, each slide takes its own
   ratio and the frame eases between them as you swipe. Desktop keeps the grid; galleries with no landscape are untouched. */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  var busy = false;
  function ratio(slide) {
    var v = parseFloat(slide.style.getPropertyValue('--media-preview-ratio'));
    if (!v) { var m = slide.querySelector('.product-media'); v = m ? parseFloat(m.style.getPropertyValue('--ratio')) : 0; }
    if (!v) { var i = slide.querySelector('img'); v = i && i.naturalWidth ? i.naturalWidth / i.naturalHeight : 0; }
    return v || 1;
  }
  function fit(track) {
    var slides = [].slice.call(track.children).filter(function (n) { return n.tagName === 'SLIDESHOW-SLIDE'; });
    if (!slides.length) return;
    var w = slides[0].getBoundingClientRect().width;
    if (!w) return;
    var hs = slides.map(function (n) { return Math.round(w / ratio(n)); });
    var x = track.scrollLeft, i = 0;
    for (var k = 0; k < slides.length; k++) if (slides[k].offsetLeft - slides[0].offsetLeft <= x + 1) i = k;
    var a = slides[i].offsetLeft - slides[0].offsetLeft, b = slides[i + 1] ? slides[i + 1].offsetLeft - slides[0].offsetLeft : a + w;
    var f = Math.max(0, Math.min(1, (x - a) / (b - a || 1)));
    var h = hs[i] + ((hs[i + 1] != null ? hs[i + 1] : hs[i]) - hs[i]) * f;
    track.style.height = Math.round(h) + 'px';
  }
  function arm(track) {
    var slides = [].slice.call(track.children).filter(function (n) { return n.tagName === 'SLIDESHOW-SLIDE'; });
    var wide = slides.some(function (n) { return ratio(n) >= 1.2; });
    if (!mq.matches || !wide) { track.removeAttribute('data-ma-fit'); track.style.height = ''; return; }
    track.setAttribute('data-ma-fit', '');
    if (!track._maFit) { track._maFit = true; track.addEventListener('scroll', function () { requestAnimationFrame(function () { fit(track); }); }, { passive: true }); }
    fit(track);
  }
  function run() {
    busy = false;
    [].forEach.call(document.querySelectorAll('media-gallery slideshow-slides, .product-information slideshow-slides'), arm);
  }
  function queue() { if (!busy) { busy = true; requestAnimationFrame(run); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', queue); else queue();
  window.addEventListener('load', queue);
  window.addEventListener('resize', queue);
  if (mq.addEventListener) mq.addEventListener('change', queue);
  if (document.body) new MutationObserver(function (ms) {
    for (var i = 0; i < ms.length; i++) { var t = ms[i].target; if (t && t.closest && t.closest('media-gallery, .product-information')) { queue(); return; } }
  }).observe(document.body, { childList: true, subtree: true });
})();
